"use strict";

const _ = require('lodash');
const GridRowComponent = require("../GridRowComponent");
const Renderer = require("./LockedGridGroupRowRenderer");

class LockedGridGroupRowComponent extends GridRowComponent {

    constructor(configOptions) {
        super(configOptions);
        this._expanded = _.get(configOptions, 'expanded', false);
        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _triggerSetExpanded(state) {
        this.emit('Expand', state);
    }
    _registerListeners(){
        super._registerListeners();
    }

    _unregisterListeners(){
        super._unregisterListeners();
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        return super.shutdown();
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/


    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/


    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    setExpanded(state) {
        state = Boolean(state);
        if (this._expanded !== state) {
            this._triggerSetExpanded(state);
            this._expanded = state;
        }
    }

    getExpanded() {
        return this._expanded;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = LockedGridGroupRowComponent;